<app-onboarding-header [showHeader]="(isOnboarding && !isOnboardingComplete) || isOnboarding"></app-onboarding-header>
<div style="/*max-width: 1520px;*/min-width: 300px; /*margin: 0 auto;*/">
    
     <!-- This is section for Real Time Marketing tracking configuration settings -->
    @if(settings?.rtmFormIntegrationEnabled)
    {
        <div id="user-tracking-form" style="display: none;"
            [attr.data-form-id]="settings?.aliceRtmDataFormId"
            [attr.data-form-api-url]="settings?.aliceRtmDataFormApiUrl"
            [attr.data-cached-form-url]="settings?.aliceRtmDataCachedFormUrl + settings?.aliceRtmDataFormId">
        </div> 
    }
     <!-- End of Real Time Marketing tracking configuration settings -->
    <svg-icon class="sxh-hidden" src="assets/icons/dist/sx-icon-sprite.svg"></svg-icon>

    <app-cookie-consent [approved]="consentApproved" [hidden]="(isPermissionLoading$|async)"></app-cookie-consent>

    <!-- Topp navbar: Show if NOT handset -->
     @if(!(isHandset$ | async)){
        <div class="body">
            @if(displayPageChrome) {
                <div class="sx-navbar fixed-top navbar-light">
                    <div class="sx-navbar__header-wrapper">
                        <header class="sx-topheader" app-header (toggleEvent)="onToggleMenu($event)" 
                            [isHandset]="isHandset$ | async"
                            [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                            [unreadNotificationCount]="unreadNotificationCount$|async"
                            [unreadMessagesCount]="unreadMessagesCount$|async" 
                            [userInfo]="userInfo$|async" 
                            [unreadNotifications$]="unreadNotifications$"
                            [bannerMessages]="bannerMessages$|async"
                            [userType]="userType$|async" 
                            [isEnableAppLauncher]="isEnableAppLauncher"
                            [meteringPoints]="meteringPoints$|async"
                            [unreadTipsCount]="unreadTipsCount$|async">
                        </header>
                    </div>
                </div>
            }
        </div>
     }

    <mat-sidenav-container #sidenavContainer class="sidenav-container" autosize="false" [ngClass]="{'sidenav-expanded' : displayPageChrome && (isLoggedInAndPermissionsLoaded$|async) && (!(isHandset$|async) && isNavigationMenuExpanded)
        , 'sidenav-collapsed' : displayPageChrome && (isLoggedInAndPermissionsLoaded$|async) && !(isHandset$|async) && !isNavigationMenuExpanded}">
        @if(displayPageChrome && (isLoggedInAndPermissionsLoaded$|async) && (isMenuItemsLoaded$|async) ){
            <mat-sidenav #drawer class="sx-sidenav"
                    [ngClass]="{'sx-sidenav-expanded' : displayPageChrome && isNavigationMenuExpanded, 'sx-sidenav-collapsed' : displayPageChrome && !(isHandset$|async) && !isNavigationMenuExpanded}" 
                    fixedInViewport="true" 
                    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                    [mode]="(isHandset$ | async) ? 'push' : 'side'" 
                    [position]="(isHandset$ | async) ? 'end' : 'start'"
                    [opened]="!(isHandset$ | async)">
                    
                    @if(isHandset$ | async){
                        <div>
                            <app-nav-buttons
                                [isHandset]="isHandset$ | async"
                                [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                                [unreadNotificationCount]="unreadNotificationCount$|async" 
                                [unreadNotifications]="unreadNotifications$|async" 
                                [unreadMessagesCount]="unreadMessagesCount$|async"
                                [bannerMessages]="bannerMessages$|async"
                                [userInfo]="userInfo$|async"
                                [unreadTipsCount]="unreadTipsCount$|async"
                                (navButtonClick)="onNavButtonClick()"
                                [meteringPoints]="meteringPoints$|async">
                            </app-nav-buttons>
                        </div>
                    }
                    <app-navigation-menu
                        [meteringPoints]="meteringPoints$|async" 
                        [menuItems]="menuItems"
                        [isExternalCustomersOnly]="isExternalCustomersOnly"
                        [isHandset]="isHandset$ | async"
                        [isExpanded]="isNavigationMenuExpanded"
                        [allowedWhiteLabelMenuItemIds]="allowedWhiteLabelMenuItemIds"
                        (navigationClick)="onNavigationClick($event)"
                        (expandChange)="onExpandChange($event)">
                    </app-navigation-menu>
            </mat-sidenav>
        }

        <mat-sidenav-content class="app-body" [ngClass]="{ 'full-screen' : !displayPageChrome }">
        <!--<mat-sidenav-content [className]="displayPageChrome ? 'app-body':'app-body full-screen'">-->
            <!-- Show if handset -->
             @if((isHandset$ | async)) {
                <div class="sx-topheader__mobile fixed-top" >
                    @if(displayPageChrome) {
                        <header class="sx-topheader" app-header (toggleEvent)="onToggleMenu($event)" 
                            [isHandset]="isHandset$ | async"
                            [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                            [unreadNotificationCount]="unreadNotificationCount$|async"
                            [unreadMessagesCount]="unreadMessagesCount$|async" 
                            [userInfo]="userInfo$|async" 
                            [unreadNotifications]="unreadNotifications$|async"
                            [bannerMessages]="bannerMessages$|async"
                            [userType]="userType$|async"
                            [isEnableAppLauncher]="isEnableAppLauncher"
                            [meteringPoints]="meteringPoints$|async"
                            [unreadTipsCount]="unreadTipsCount$|async">
                        </header>
                    }
                </div>
            }
            
            <div class="app-body__main" >
                <main app-content>
                    @if((isLoggedInAndPermissionsLoaded$|async) && !isOnboarding){
                        <app-registration-pane></app-registration-pane>
                    }
                    @if(!isOnboarding){
                        <app-system-message-pane
                            [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async"
                            [bannerMessages]="bannerMessages$|async">
                        </app-system-message-pane>
                    }
                    <div [class.app-body__main-onboarding]="isOnboarding">
                        <router-outlet (activate)="onActivate($event)"></router-outlet>
                    </div>
                </main>
               
                <footer class="sx-footer" >

                     <div class="sx-footer__in-row-icons">
                        <img class="sx-footer__logo"  src="/assets/icons/stockholm-exergi-logo.svg" />
                        <div class="sx-footer__in-socialmedia">

                            <a  target="_blank" href="https://x.com/SthlmExergi" class="social-icon" >
                                <svg>
                                    <use xlink:href="#twitter-river" href="#twitter-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.linkedin.com/company/stockholm-exergi/" class="social-icon" >
                                <svg>
                                    <use xlink:href="#linkedin-river" href="#linkedin-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.instagram.com/stockholmexergi/" class="social-icon">
                                <svg>
                                    <use xlink:href="#instagram-river" href="#instagram-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.facebook.com/stockholmexergi" class="social-icon" >
                                <svg>
                                    <use xlink:href="#fb-river" href="#fb-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.youtube.com/channel/UCGd9A2kKWSDgZqTpAgWtIJQ" class="social-icon" >
                                <svg>
                                    <use xlink:href="#youtube-river" href="#youtube-river" />
                                </svg>
                            </a>
                        </div>
                     </div>
                  
                    <div class="sx-footer__in-row sx-footer__in-text">
                        <div>
                            <p class="sx-footer__ingress">{{'main.footer.ingress' | translate}}</p>
                        </div>
                        <div>
                            <p class="sx-footer__ingress sx-footer__ingress--right">© Stockholm Exergi AB <br>Org.nr: 556016-9095</p>
                        </div>
                    </div>
                </footer>
            </div>
            @if(displayPageChrome && (currentHelpState$|async) !== inActiveHelp){
                <app-help class="app-body__help"></app-help>
            }
            @if((isShowTips$|async)){
                <app-tips class="sx-tips-container" [tips]="(tips$ | async)"></app-tips>
            }
        </mat-sidenav-content>

    </mat-sidenav-container>
</div>
